import { getGame } from "@/services/game-service";
import { Game } from "@/types/GameType";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import ms from "ms";

const useGame = (slug: string) => {
    return useQuery<Game, Error>({
        queryKey: ['games', slug],
        queryFn: () => getGame(slug), // Pass a function reference
        placeholderData: keepPreviousData,
        staleTime: ms('24h')
    })
};

export default useGame;
